import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'getm-favs-progress-bar',
  templateUrl: './favs-progress-bar.component.html',
  styleUrls: ['./favs-progress-bar.component.scss'],
})
export class FavsProgressBarComponent implements OnInit {

  @Input() value: number = 0;
  @Input() maxValue: number = 0;
  @Input() color: string = 'getm-category-gana-mas';

  constructor() { }

  ngOnInit() { }

}
